import { useMemo, useState } from 'react'
import AgendamentosEntregaHttp from '../../../../../services/api/https/deliveries/agendamentos-entrega.http'

import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INITIAL_INFO: 'Adquirindo agendamentos',
  SAVE_REASON: 'Salvando informações',
  SUCCESS: 'Informações salvas com sucesso',
}

const INITIAL_STATE = {
  globalFilter: '',
  agendamentos: [],
  loadingMessage: LOAD_MESSAGE.GET_INITIAL_INFO,
  errorMessage: null,
  modalAgendamentos: {
    data: null,
    show: false,
  },
}

export const MENU_ITEMS = ['Datas de Agendamentos']

export default function useAgendamentoEntrega() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      async getAgendamentosEntrega(delivery_id) {
        await AgendamentosEntregaHttp.getAgendamentosEntrega(delivery_id)
          .then(agendamentos =>
            setState(prevState => ({
              ...prevState,
              agendamentos,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onBtnNovoClicked(delivery_id) {
        setState(prevState => ({
          ...prevState,
          modalAgendamentos: {
            data: { delivery_id, id: null, date: null },
            show: true,
          },
        }))
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modalAgendamentos: {
            data: null,
            show: false,
          },
        }))
      },

      onModalSave(agendamento) {
        setState(prevState => {
          const index = prevState.agendamentos.findIndex(i => i.id === agendamento.id)
          if (index !== -1) {
            prevState.agendamentos[index] = agendamento
          } else prevState.agendamentos.push(agendamento)

          return {
            ...prevState,
            modalAgendamentos: {
              data: null,
              show: false,
            },
          }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
